import React from 'react';

const InfoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer circle */}
      <circle
        cx="10"
        cy="10"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      {/* Exclamation mark: vertical line */}
      <path
        d="M10 5 V12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Exclamation mark: dot */}
      <circle cx="10" cy="15" r="1" fill="currentColor" />
    </svg>
  );
};

export default InfoIcon;
